module.exports = __webpack_public_path__ + "assets/img/86@3x.0de6145b.png";